<template>
  <div>
  <Header />
  <!-- <BreadCrumb :valueFromParent="parentValue" /> -->
  <BreadCrumb
   title="Deletion Policy"        
        :breadcrumbs="[{ text: 'Deletion Policy', to: '/deletion-policy' }]"
  />
 <DeletionPolicy :isWebTarget="true"/>
  <Newsletter />
  <Footer />
  </div>
</template>

<script setup>
import DeletionPolicy from '@/components/DeletionPolicy.vue'
import Newsletter from "@/components/NewsletterBox.vue";
import Header from "@/components/Header.vue";
import BreadCrumb from "@/components/BreadCrumb.vue";
import Footer from "@/components/FooterArea.vue";
import "@fortawesome/fontawesome-free/css/all.css";
import { ref, onMounted } from "vue";
// export default {
//   name: "Terms and Conditions",
//   components: {
//     Header,
//     BreadCrumb,
//     Newsletter,
//     Footer,
//   },
//   setup() {
//     // Define a reactive variable to hold the title
//     const pageTitle = ref("Salt - Deletion Policy");

//     // Function to update the title
//     const updateTitle = () => {
//       document.title = pageTitle.value;
//     };

//     // Call updateTitle when component is mounted
//     onMounted(() => {
//       updateTitle();
//     });

//     return {
//       pageTitle,
//       updateTitle,
//     };
//   },
// };
</script>

<style scoped>
.aboutus {
  padding: 70px 0 50px 0;
}
.textStyle {
  text-align: left;
}
.aboutus img {
  max-width: 100%;
}
.aboutus h2 {
  font-size: 55px;
  max-width: 100%;
  margin-bottom: 20px;
}
</style>
